import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>About us</h2>
        <p>
        First Step House has designed a set of assessment-drive, evidence-based interventions that are known to be effective in addressing the factors that contribute to instability, relapse, homelessness, and unemployment. All of our programs and services utilize evidence-based modalities targeted for low-income individuals with substance use disorders and mental health conditions.
        </p>
        <p>
        Our goal is to create a community that allows people to engage in treatment on multiple levels. To accomplish this goal, we address the unique needs of each client by creating individualized treatment and case-management plans to address multiple domains of concern (e.g., physical health, environment, family relations).
        </p>
        <a
          href="https://g.co/kgs/yx9wYjo"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit First Step House - Central City Residential Campus
        </a>
        <br />
        <br />
        <a
          href="https://g.co/kgs/25sNxUc"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vist First Step House - Fairpark Residential Campus
        </a>

        <br />
        <br />
        <a
          href="https://g.co/kgs/64JQexo"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vist First Step House - Reach
        </a>

        <br />
        <br />
        <a
          href="https://g.co/kgs/Tr85HvE"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vist First Step House - Outpatient
        </a>
      </Wrap>
    </>
  );
};

export default Content;
